import { JsonEditor as JsonEditorComponent } from 'json-edit-react'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './JsonEditor.module.scss'

const jsonEditorTheme = {
  styles: {
    container: {
      backgroundColor: 'var(--bs-secondary-bg)',
      color: 'var(--bs-body-color)',
    },
    property: 'var(--aug-json-key)',
    bracket: { color: 'var(--aug-json-bracket)', fontWeight: 'bold' },
    itemCount: { color: 'var(--aug-color-label-2)', fontStyle: 'normal' },
    string: 'var(--aug-json-string)',
    number: 'var(--aug-json-attr)',
    boolean: 'var(--aug-json-number)',
    null: { color: 'var(--aug-json-meta)', fontVariant: 'small-caps', fontWeight: 'bold' },
    input: [
      'var(--bs-body-color)',
      {
        backgroundColor: 'var(--bs-tertiary-bg)',
        border: '1px solid var(--bs-border-color)',
        color: 'var(--bs-body-color)',
        fontSize: '90%',
      },
    ],
    inputHighlight: 'var(--aug-json-input-highlight)',
    error: { color: 'var(--bs-danger)', fontSize: '0.8em', fontWeight: 'bold' },
    iconCollection: 'var(--aug-json-bracket)',
    iconEdit: 'var(--bs-body-color)',
    iconDelete: 'var(--bs-danger)',
    iconAdd: 'var(--bs-success)',
    iconCopy: 'var(--bs-body-color)',
    iconOk: 'var(--bs-success)',
    iconCancel: 'var(--bs-danger)',
    iconDrag: 'var(--bs-secondary-color)',
  },
}

const propTypes = {
  /**
   * Editable JSON root (object or array). Pass `{}` when the value is empty.
   */
  jsonEditorPayload: PropTypes.oneOfType([PropTypes.object, PropTypes.array]), // eslint-disable-line react/forbid-prop-types
  /**
   * Callback to update the policy object
   */
  setJsonEditorPayload: PropTypes.func.isRequired,
  /**
   * validation errors for the json editor
   */
  jsonEditorErrors: PropTypes.arrayOf(PropTypes.string),
  /**
   * Label for the root node in the tree (e.g. `Policy` for templates, shorter label for inline fields).
   */
  rootName: PropTypes.string,
}

function JsonEditor(props) {
  const { jsonEditorPayload = {}, setJsonEditorPayload, jsonEditorErrors = [], rootName = 'Policy' } = props ?? {}

  return (
    <>
      <div className={jsonEditorErrors?.length ? 'mb-3' : ''}>
        {jsonEditorErrors?.map((error) => (
          <div key={error} className="text-color-danger mb-2">
            {error}
          </div>
        ))}
      </div>
      <form spellCheck="false">
        <JsonEditorComponent
          data={jsonEditorPayload}
          rootName={rootName}
          setData={setJsonEditorPayload}
          collapse={2}
          theme={jsonEditorTheme}
          className={styles.jsonEditor}
        />
      </form>
    </>
  )
}

JsonEditor.propTypes = propTypes

export default JsonEditor
